// Function definitions
const _mapTimeSlot = function (ts) {
    ts.start = window.moment(ts.start);
    ts.end = window.moment(ts.end);
    return ts;
};

const search = function (params = {}) {
    return new Promise((fulfill, reject) => {
        window.axios.get('/api/timeslots', {
            params: params,
        }).then(xhr => {
            let timeSlots = [];
            for (let index in xhr.data) {
                timeSlots.push(_mapTimeSlot(xhr.data[index]));
            }
            xhr.data = timeSlots;
            fulfill(xhr);
        }, error => {
            reject(error);
        })
    });
};

const get = function (id) {
    return new Promise((fulfill, reject) => {
        window.axios.get('/api/timeslots/' + id).then(xhr => {
            xhr.data = _mapTimeSlot(xhr.data);
            fulfill(xhr);
        }, error => {
            reject(error);
        });
    });
};

const create = function (timeslot) {
    return window.axios.post('/api/timeslots', timeslot);
};

const update = function (timeslot) {
    return window.axios.put('/api/timeslots/' + timeslot.id, timeslot);
};

const deleteTimeSlot = function (timeslot) {
    return window.axios.delete('/api/timeslots/' + timeslot.id, timeslot);
};

const updateOrCreate = function (timeslot) {
    if (timeslot.id) {
        return update(timeslot);
    } else {
        return create(timeslot);
    }
};

const validateTimeSlot = function (timeSlot) {
    return window.axios.post('/api/timeslots/validate', timeSlot);
};

export default {
    search,
    get,
    create,
    update,
    delete: deleteTimeSlot,
    updateOrCreate,
    validateTimeSlot,
    _mapTimeSlot,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/TimeSlotsService.js